module.exports = __webpack_public_path__ + "static/media/warranty-popup-image.4578483e.png";